module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hI1MW"))).then(() => parcelRequire('fThBo'));